// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"FeedbackButoon_feedbackContainer__Oe8f1","feedbackButton":"FeedbackButoon_feedbackButton__s-jdS"};